export default "__VITE_ASSET__8a6111d3__"